import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import UmbracoForm from './UmbracoForm';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <UmbracoForm />
  </React.StrictMode>,
  document.getElementById('react-form-umbraco')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
